import { render } from "./InterviewFooter.vue?vue&type=template&id=a5c9858e"
import script from "./InterviewFooter.vue?vue&type=script&lang=js"
export * from "./InterviewFooter.vue?vue&type=script&lang=js"

import "./InterviewFooter.vue?vue&type=style&index=0&id=a5c9858e&lang=css"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__